import React from 'react';
import ReactModal from 'react-modal';
import cn from 'classnames';

import { getScrollbarWidth } from '../utils';
import YellowWarningCircleIcon from 'images/icons/YellowWarningCircleIcon';

import styles from './styles.module.scss';
import Spinner from 'components/Spinner';
import CloseIcon from 'images/icons/CloseIcon';

class ConfirmModalV2 extends React.Component {
  componentDidMount() {
    document.addEventListener('keydown', this.handleEscape);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscape);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      if (this.props.isOpen) {
        const scrollWidth = getScrollbarWidth();
        document.body.style.overflowY = 'hidden';
        document.body.style.paddingRight = `${scrollWidth}px`;
      } else {
        document.body.style.overflowY = 'auto';
        document.body.style.paddingRight = `0px`;
      }
    }
  }

  handleEscape = (event) => {
    const { isOpen, onClose } = this.props;
    if (event.keyCode === 27 && isOpen) {
      onClose();
    }
  };

  confirmHandler = (e) => {
    const { onConfirm, onClose, closeOnConfirmClick = false } = this.props;
    onConfirm(e);
    closeOnConfirmClick && onClose();
  };

  render() {
    const {
      onClose,
      confirmBtnText = 'Save',
      cancelBtnText = 'Cancel',
      isOpen = false,
      title = '',
      className,
      loading,
      text,
    } = this.props;

    return (
      <ReactModal
        appElement={document.getElementById('root')}
        isOpen={isOpen}
        overlayClassName={styles.backdrop}
        className={cn(styles.modal, className)}
      >
        <div className={styles.header}>
          <h2 className={cn('h2', styles.title)}>{title}</h2>
          <CloseIcon className={styles.closeIcon} onClick={onClose} />
        </div>
        <div className={styles.content}>
          <div className={styles.textWrapper}>
            <YellowWarningCircleIcon />
            <p className={styles.text}>{text}</p>
          </div>
          <div className={styles.buttonsWrapper}>
            <button
              className={cn('btn btn-primary', styles.yesBtn)}
              onClick={this.confirmHandler}
            >
              {confirmBtnText}
            </button>
            <button
              onClick={onClose}
              className={cn('btn btn-default', styles.noBtn)}
            >
              {cancelBtnText}
            </button>
          </div>
        </div>
        <Spinner showLoader={loading} />
      </ReactModal>
    );
  }
}

export default ConfirmModalV2;
